var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlanDiamond = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "59px",
    viewBox: "0 0 53 59",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-212.000000, -130.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.000000, 103.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.000000, 27.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E0EDFF",
    transform: "translate(11.178589, 2.789654) rotate(-45.000000) translate(-11.178589, -2.789654) ",
    points: "9.01600209 1.71949475 13.3560219 1.68980414 13.3411766 3.85981403 9.00115679 3.88950464"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E0EDFF",
    transform: "translate(2.415891, 11.671595) rotate(-45.000000) translate(-2.415891, -11.671595) ",
    points: "0.253303299 10.6014356 4.59332309 10.571745 4.57847778 12.7417549 0.238457996 12.7714455"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E0EDFF",
    transform: "translate(2.416319, 2.402475) rotate(-45.000000) translate(-2.416319, -2.402475) ",
    points: "1.34615984 0.239887295 3.51616973 0.225041991 3.48647913 4.56506178 1.31646923 4.57990708"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E0EDFF",
    points: "26.5 57 51 28.3806829 42.4108444 13 26.5043556 13 10.5891556 13 2 28.3806829"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E0EDFF",
    points: "15 28 26 13 37 28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,28 L51,28 L2,28 Z",
    fill: "#E0EDFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E0EDFF",
    points: "43 13 27.5 57 12 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "6.24489796 28.3806829 14.6158367 13 10.3709388 13 2 28.3806829 25.877551 57 28 54.4565854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0010834,59 C26.5222119,59 26.0671756,58.7906364 25.7594844,58.4295909 L1.38254124,29.9433182 C0.949173357,29.437 0.877667657,28.7191818 1.20052673,28.1380909 L9.74437447,12.8289091 C10.0303973,12.3161818 10.5764408,12 11.167988,12 L42.832012,12 C43.4235592,12 43.9696027,12.3161818 44.2556255,12.8310455 L52.7994733,28.1402273 C53.1223323,28.7191818 53.0508266,29.437 52.6174588,29.9454545 L28.2405156,58.4317273 C27.9349912,58.7906364 27.4799549,59 27.0010834,59 Z M4.58512986,28.7191818 L27.0010834,54.9131364 L49.417037,28.7191818 L41.8721022,15.2045455 L12.1300646,15.2045455 L4.58512986,28.7191818 Z",
    fill: "#0049FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2538722,30 L26.5,16.3942908 L16.7461278,29.9978591 L14,28.1737734 L25.1269361,12.6519179 C25.7478191,11.782694 27.2521809,11.782694 27.8730639,12.6519179 L39,28.1737734 L36.2538722,30 Z",
    fill: "#0049FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0049FF",
    points: "2 26 51 26 51 29 2 29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9680671,59 C26.2967982,59 25.6975267,58.5650172 25.4730645,57.9114501 L10,13.101665 L12.9900051,12 L26.9680671,52.477444 L32.0099949,37.8760115 L35,38.9776765 L28.4630696,57.9114501 C28.2386075,58.5650172 27.6393359,59 26.9680671,59 Z",
    fill: "#0049FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0049FF",
    transform: "translate(38.722160, 23.666887) rotate(-70.369298) translate(-38.722160, -23.666887) ",
    points: "26.8563033 22.0997578 50.6021029 21.9974927 50.5880158 25.2340171 26.8422162 25.3362821"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlanDiamond, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plan-diamond.3994286e.svg";
export { ForwardRef as ReactComponent };